module.exports = __webpack_public_path__ + "static/media/logo.71724d79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 359
// module chunks = 0